module.exports = __webpack_public_path__ + "static/media/saunaIcon.045b8dd8.svg";